export const questionsTranslate = {
	a01: {
		es: 'Busco comprender a los demás reconociendo sus emociones.',
		pt: 'Busco compreender os outros reconhecendo suas emoções.',
		en: 'I seek to understand others by recognizing their emotions.',
	},
	a02: {
		es: 'Tiendo a basarme en suposiciones, sin hacer consultas para confirmar datos.',
		pt: 'Tendo a basear-me em suposições, sem fazer consultas para confirmar dados.',
		en: 'I tend to rely on assumptions, without making inquiries to confirm data.',
	},
	a03: {
		es: 'Busco conocer las habilidades y conocimientos de mis compañeros de trabajo.',
		pt: 'Busco conhecer as habilidades e conhecimentos dos meus colegas de trabalho.',
		en: 'I seek to know the skills and knowledge of my coworkers.',
	},
	a04: {
		es: 'Suelo mostrarme ansioso frente a una situacion de cambio.',
		pt: 'Costumo mostrar-me ansioso diante de uma situação de mudança.',
		en: 'I usually appear anxious in the face of a changing situation.',
	},
	a05: {
		es: 'Suelo adelantarme a los hechos e implementar planes para poder concretar mis proyectos.',
		pt: 'Costumo antecipar os fatos e implementar planos para concretizar meus projetos.',
		en: 'I tend to anticipate events and implement plans to achieve my projects.',
	},
	a06: {
		es: 'No tengo problemas para asumir riesgos controlados en la toma de decisiones.',
		pt: 'Não tenho problemas para assumir riscos controlados na tomada de decisões.',
		en: 'I have no problems taking controlled risks in decision-making.',
	},
	a07: {
		es: 'Me motiva resolver los obstáculos que surgen.',
		pt: 'Sou motivado a resolver os obstáculos que surgem.',
		en: 'I am motivated to solve the obstacles that arise.',
	},
	a08: {
		es: 'Entiendo la negociación como un proceso en el que ambas partes deben ganar.',
		pt: 'Entendo a negociação como um processo no qual ambas as partes devem ganhar.',
		en: 'I understand negotiation as a process in which both parties must win.',
	},
	a09: {
		es: 'Me motiva el logro de objetivos complejos y tiendo a sentirme satisfecho con mi desempeño.',
		pt: 'Sou motivado pela conquista de objetivos complexos e costumo sentir-me satisfeito com meu desempenho.',
		en: 'I am motivated by achieving complex goals and tend to feel satisfied with my performance.',
	},
	a10: {
		es: 'Me cuesta relacionarme y entrar en confianza con personas nuevas.',
		pt: 'Tenho dificuldade em relacionar-me e ganhar confiança com pessoas novas.',
		en: 'I find it difficult to relate to and build trust with new people.',
	},
	a11: {
		es: 'Mantengo contacto constante con clientes internos y externos para estar al tanto de sus inquietudes.',
		pt: 'Mantenho contato constante com clientes internos e externos para estar ciente de suas preocupações.',
		en: 'I maintain constant contact with internal and external clients to stay aware of their concerns.',
	},
	a12: {
		es: 'Tiendo a relacionarme con los demás de modo abierto, sin importar su religión, nacionalidad u orientación sexual.',
		pt: 'Tenho tendência a relacionar-me com os outros de forma aberta, independentemente de sua religião, nacionalidade ou orientação sexual.',
		en: 'I tend to relate to others openly, regardless of their religion, nationality, or sexual orientation.',
	},
	a13: {
		es: 'Estoy atento al equilibrio entre mi vida laboral y personal.',
		pt: 'Estou atento ao equilíbrio entre minha vida laboral e pessoal.',
		en: 'I pay attention to the balance between my work and personal life.',
	},
	a14: {
		es: 'Fomento un clima de armonía y respeto en mi grupo buscando que todos den lo mejor de sí.',
		pt: 'Promovo um clima de harmonia e respeito em meu grupo, buscando que todos deem o melhor de si.',
		en: 'I foster an atmosphere of harmony and respect in my group, aiming for everyone to give their best.',
	},
	a15: {
		es: 'Me cuesta manejar mi agenda y suelo sentirme superado para establecer prioridades y urgencias.',
		pt: 'Tenho dificuldade em gerenciar minha agenda e costumo sentir-me sobrecarregado para estabelecer prioridades e urgências.',
		en: 'I struggle to manage my schedule and often feel overwhelmed in setting priorities and urgencies.',
	},
	a16: {
		es: 'Reflexiono sobre mí mismo: me pregunto qué deseo, quién soy.',
		pt: 'Reflexiono sobre mim mesmo: questiono o que desejo, quem sou.',
		en: 'I reflect on myself: I ask myself what I want, who I am.',
	},
	a17: {
		es: 'Encaro nuevas situaciones con soluciones creativas y originales.',
		pt: 'Enfrento novas situações com soluções criativas e originais.',
		en: 'I face new situations with creative and original solutions.',
	},
	a18: {
		es: 'Busco constantemente superarme y aprender.',
		pt: 'Busco constantemente superar-me e aprender.',
		en: 'I constantly seek to improve myself and learn.',
	},
	a20: {
		es: 'Tengo la capacidad de gestionar con un alto nivel de influencia involucrando a otros.',
		pt: 'Tenho a capacidade de gerir com um alto nível de influência, envolvendo outros.',
		en: 'I have the ability to manage with a high level of influence, involving others.',
	},
	a21: {
		es: 'Los cambios del entorno me suelen alterar y estresar.',
		pt: 'As mudanças no ambiente costumam me perturbar e estressar.',
		en: 'Environmental changes usually unsettle and stress me.',
	},
	b01: {
		es: 'Promuevo que en una conversación los demás se puedan expresar con libertad y confianza.',
		pt: 'Promovo que, em uma conversa, os outros possam se expressar com liberdade e confiança.',
		en: 'I promote an environment where others can express themselves freely and confidently in a conversation.',
	},
	b02: {
		es: 'Suelo escuchar con atención antes de dar mi opinión.',
		pt: 'Costumo ouvir com atenção antes de dar minha opinião.',
		en: 'I tend to listen carefully before giving my opinion.',
	},
	b03: {
		es: 'Soy receptivo ante distintos puntos de vista y los integro para mejorar mi desempeño.',
		pt: 'Sou receptivo a diferentes pontos de vista e os integro para melhorar meu desempenho.',
		en: 'I am receptive to different points of view and integrate them to improve my performance.',
	},
	b04: {
		es: 'Pienso y reacciono con rapidez al adaptarme a una nueva situación.',
		pt: 'Penso e reajo rapidamente ao me adaptar a uma nova situação.',
		en: 'I think and react quickly when adapting to a new situation.',
	},
	b05: {
		es: 'Identifico cómo los procesos del equipo aportan al logro de los objetivos de la empresa.',
		pt: 'Identifico como os processos da equipe contribuem para a conquista dos objetivos da empresa.',
		en: 'I identify how the team processes contribute to achieving the company’s objectives.',
	},
	b06: {
		es: 'Efectúo un análisis racional y emocional de distintas alternativas antes de tomar una decisión.',
		pt: 'Faço uma análise racional e emocional de diferentes alternativas antes de tomar uma decisão.',
		en: 'I perform a rational and emotional analysis of different alternatives before making a decision.',
	},
	b07: {
		es: 'Para mí los problemas son una "oportunidad".',
		pt: 'Para mim, os problemas são uma "oportunidade".',
		en: 'For me, problems are an "opportunity."',
	},
	b08: {
		es: 'Tiendo a imponer mis condiciones en una negociación.',
		pt: 'Tenho tendência a impor minhas condições em uma negociação.',
		en: 'I tend to impose my conditions in a negotiation.',
	},
	b09: {
		es: 'Los objetivos de la organización me resultan muy exigentes, por lo que elijo focalizarme en los propios.',
		pt: 'Os objetivos da organização me parecem muito exigentes, então escolho focar nos meus próprios.',
		en: 'The organization’s goals seem very demanding to me, so I choose to focus on my own.',
	},
	b10: {
		es: 'Me resulta sencillo ser empático con mis pares, clientes y colaboradores.',
		pt: 'Acho fácil ser empático com meus pares, clientes e colaboradores.',
		en: 'I find it easy to be empathetic with my peers, clients, and collaborators.',
	},
	b11: {
		es: 'Indago formal o informalmente, para evaluar la calidad de mis servicios.',
		pt: 'Investigo formal ou informalmente para avaliar a qualidade dos meus serviços.',
		en: 'I inquire formally or informally to assess the quality of my services.',
	},
	b12: {
		es: 'Me cuesta respetar y aceptar las diferencias entre personas.',
		pt: 'Tenho dificuldade em respeitar e aceitar as diferenças entre as pessoas.',
		en: 'I find it difficult to respect and accept differences between people.',
	},
	b13: {
		es: 'Considero que mi trabajo está en sintonía con mis valores y objetivos de vida.',
		pt: 'Considero que meu trabalho está em sintonia com meus valores e objetivos de vida.',
		en: 'I believe my work aligns with my values and life goals.',
	},
	b14: {
		es: 'Logro estimular a los demás en el logro de objetivos personales y organizacionales.',
		pt: 'Consigo estimular os outros na conquista de objetivos pessoais e organizacionais.',
		en: 'I succeed in motivating others to achieve personal and organizational goals.',
	},
	b15: {
		es: 'Realizo una adecuada planificación de tiempos y recursos.',
		pt: 'Realizo uma adequada planificação de tempos e recursos.',
		en: 'I carry out proper planning of time and resources.',
	},
	b16: {
		es: 'Intento conocer la mejor versión de mí mismo, integrando las distintas partes de mi personalidad.',
		pt: 'Tento conhecer a melhor versão de mim mesmo, integrando as diferentes partes da minha personalidade.',
		en: 'I try to know the best version of myself, integrating different parts of my personality.',
	},
	b17: {
		es: 'Busco inspirarme a través de nuevos estímulos para lograr respuestas innovadoras.',
		pt: 'Busco me inspirar através de novos estímulos para encontrar respostas inovadoras.',
		en: 'I seek inspiration through new stimuli to achieve innovative solutions.',
	},
	b18: {
		es: 'Identifico a consciencia mis oportunidades de mejora para poder cambiarlo.',
		pt: 'Identifico conscientemente minhas oportunidades de melhora para poder mudá-las.',
		en: 'I consciously identify my improvement opportunities to make changes.',
	},
	b20: {
		es: 'Transmito una visión inspiradora, mostrando el camino a los demás.',
		pt: 'Transmito uma visão inspiradora, mostrando o caminho aos outros.',
		en: 'I convey an inspiring vision, showing the way to others.',
	},
	b21: {
		es: 'Identifico y flexibilizo mis propias resistencias.',
		pt: 'Identifico e flexibilizo minhas próprias resistências.',
		en: 'I identify and adapt my own resistances.',
	},
	c01: {
		es: 'Suelo preguntar para asegurarme que entiendo lo que estoy escuchando.',
		pt: 'Costumo perguntar para me certificar de que entendo o que estou ouvindo.',
		en: 'I usually ask questions to make sure I understand what I am hearing.',
	},
	c02: {
		es: 'Suelo utilizar las herramientas necesarias para comunicar acorde a la situación',
		pt: 'Costumo utilizar as ferramentas necessárias para comunicar de acordo com a situação.',
		en: 'I tend to use the necessary tools to communicate according to the situation.',
	},
	c03: {
		es: 'Me adapto a las necesidades y requerimientos del equipo para el logro de metas comunes.',
		pt: 'Adapto-me às necessidades e requisitos da equipe para alcançar metas comuns.',
		en: 'I adapt to the needs and requirements of the team to achieve common goals.',
	},
	c04: {
		es: 'Me considero abierto a aprender cosas nuevas.',
		pt: 'Considero-me aberto a aprender coisas novas.',
		en: 'I consider myself open to learning new things.',
	},
	c05: {
		es: 'Tiendo a dar seguimiento a los planes de acción vinculados a la organización.',
		pt: 'Tenho a tendência de acompanhar os planos de ação vinculados à organização.',
		en: 'I tend to follow up on action plans linked to the organization.',
	},
	c06: {
		es: 'Siento que mis decisiones agregan valor a la organización.',
		pt: 'Sinto que minhas decisões agregam valor à organização.',
		en: 'I feel that my decisions add value to the organization.',
	},
	c07: {
		es: 'Logro salir fortalecido de los fracasos y obstáculos.',
		pt: 'Consigo sair fortalecido dos fracassos e obstáculos.',
		en: 'I manage to come out stronger from failures and obstacles.',
	},
	c08: {
		es: 'Recopilo y sistematizo información que resulta útil para una negociación',
		pt: 'Reúno e sistematizo informações que são úteis para uma negociação.',
		en: 'I gather and systematize information that is useful for a negotiation.',
	},
	c09: {
		es: 'Suelo chequear los procesos y así evaluar los avances de las tareas.',
		pt: 'Costumo verificar os processos e assim avaliar o progresso das tarefas.',
		en: 'I usually check processes to assess task progress.',
	},
	c10: {
		es: 'Busco fomentar redes de trabajo productivas y positivas ',
		pt: 'Busco promover redes de trabalho produtivas e positivas.',
		en: 'I seek to foster productive and positive work networks.',
	},
	c11: {
		es: 'Busco sistemáticamente ofrecer apoyo eficiente a mis clientes',
		pt: 'Busco sistematicamente oferecer apoio eficiente aos meus clientes.',
		en: 'I systematically seek to provide efficient support to my clients.',
	},
	c12: {
		es: 'Incorporo la diversidad a los equipos porque enriquece los puntos de vista y el trabajo.',
		pt: 'Incorporo a diversidade às equipes porque enriquece os pontos de vista e o trabalho.',
		en: 'I incorporate diversity into teams because it enriches perspectives and work.',
	},
	c13: {
		es: 'Propicio un ambiente de confianza, empatía y equilibrio en mis entornos sociales.',
		pt: 'Promovo um ambiente de confiança, empatia e equilíbrio em meus ambientes sociais.',
		en: 'I foster an environment of trust, empathy, and balance in my social settings.',
	},
	c14: {
		es: 'Inspiro a los demás con mi ejemplo',
		pt: 'Inspiro os outros com meu exemplo.',
		en: 'I inspire others with my example.',
	},
	c15: {
		es: 'Controlo los avances en proyectos y procesos a fin de realizar ajustes a tiempo.',
		pt: 'Controlo os avanços em projetos e processos para realizar ajustes a tempo.',
		en: 'I monitor progress in projects and processes to make timely adjustments.',
	},
	c16: {
		es: 'Estoy atento a mis fortalezas y oportunidades de mejora.',
		pt: 'Estou atento às minhas fortalezas e oportunidades de melhora.',
		en: 'I am aware of my strengths and opportunities for improvement.',
	},
	c17: {
		es: 'Amplío mi visión con nuevas miradas y estimulos externos.',
		pt: 'Amplio minha visão com novas perspectivas e estímulos externos.',
		en: 'I broaden my vision with new perspectives and external stimuli.',
	},
	c18: {
		es: 'Intento reconocer lo que no sé y asumo el desafío de aprender lo nuevo.',
		pt: 'Tento reconhecer o que não sei e assumo o desafio de aprender algo novo.',
		en: 'I try to recognize what I do not know and take on the challenge of learning something new.',
	},
	c20: {
		es: 'Mi visión me permite estar un paso adelante preparando el camino para que otros puedan transitarlo.',
		pt: 'Minha visão me permite estar um passo à frente, preparando o caminho para que outros possam segui-lo.',
		en: 'My vision allows me to stay one step ahead, preparing the way for others to follow.',
	},
	c21: {
		es: 'Influencio activamente a otros para sumarse a los procesos cambio.',
		pt: 'Influencio ativamente os outros para se unirem aos processos de mudança.',
		en: 'I actively influence others to join change processes.',
	},
	d01: {
		es: 'Tiendo a aleccionar a través de monólogos.',
		pt: 'Tenho tendência a ensinar através de monólogos.',
		en: 'I tend to teach through monologues.',
	},
	d02: {
		es: 'Pido feedback para verificar que mi mensaje se entendió',
		pt: 'Peço feedback para verificar se minha mensagem foi entendida.',
		en: 'I ask for feedback to ensure my message was understood.',
	},
	d03: {
		es: 'Busco fortalecer los vínculos de los miembros del equipo.',
		pt: 'Busco fortalecer os vínculos entre os membros da equipe.',
		en: 'I seek to strengthen the bonds between team members.',
	},
	d04: {
		es: 'Me resulta difícil reemplazar planes y procedimientos habituales por otros nuevos.',
		pt: 'Tenho dificuldade em substituir planos e procedimentos habituais por outros novos.',
		en: 'I find it difficult to replace habitual plans and procedures with new ones.',
	},
	d05: {
		es: 'Me cuesta anticipar tendencias o factores que puedan influir en mi proyecto.',
		pt: 'Tenho dificuldade em antecipar tendências ou fatores que possam influenciar meu projeto.',
		en: 'I struggle to anticipate trends or factors that may influence my project.',
	},
	d06: {
		es: 'Antepongo en mis decisiones las políticas y normas de la organización.',
		pt: 'Dou prioridade em minhas decisões às políticas e normas da organização.',
		en: 'I prioritize organizational policies and standards in my decisions.',
	},
	d07: {
		es: 'Puedo identificar lo positivo de un resultado que no cumpla con mis expectativas',
		pt: 'Consigo identificar o lado positivo de um resultado que não atenda às minhas expectativas.',
		en: 'I can identify the positives of a result that does not meet my expectations.',
	},
	d08: {
		es: 'Tengo facilidad para persuadir a otras personas y llegar a un acuerdo.',
		pt: 'Tenho facilidade para persuadir outras pessoas e chegar a um acordo.',
		en: 'I am good at persuading others and reaching an agreement.',
	},
	d09: {
		es: 'Soy persistente en la ejecución de acciones para lograr una meta',
		pt: 'Sou persistente na execução de ações para alcançar uma meta.',
		en: 'I am persistent in executing actions to achieve a goal.',
	},
	d10: {
		es: 'Utilizo la escucha activa ante un conflicto en mi entorno.',
		pt: 'Utilizo a escuta ativa diante de um conflito em meu ambiente.',
		en: 'I use active listening in the face of conflict in my environment.',
	},
	d11: {
		es: 'Aplico benchmarking (exploración de competidores) para mantener actualizados mis servicios',
		pt: 'Aplico benchmarking (exploração de concorrentes) para manter meus serviços atualizados.',
		en: 'I apply benchmarking (competitor exploration) to keep my services up to date.',
	},
	d12: {
		es: 'Trabajo sobre mis creencias y prejuicios, descartando la idea de una única verdad.',
		pt: 'Trabalho sobre minhas crenças e preconceitos, descartando a ideia de uma única verdade.',
		en: 'I work on my beliefs and prejudices, discarding the idea of a single truth.',
	},
	d13: {
		es: 'Cuido mi salud física y mental: duermo y me alimento bien, hago ejercicio físico, doy lugar a mis relaciones socio-afectivas, fomento tener hobbies,etc..',
		pt: 'Cuido da minha saúde física e mental: durmo e me alimento bem, faço exercícios físicos, dou espaço para minhas relações socioafetivas, incentivo a ter hobbies, etc.',
		en: 'I take care of my physical and mental health: I sleep and eat well, exercise, give space to my social and emotional relationships, and encourage hobbies, etc.',
	},
	d14: {
		es: 'Me interesa conocer y apoyar a cada miembro de mi grupo.',
		pt: 'Tenho interesse em conhecer e apoiar cada membro do meu grupo.',
		en: 'I am interested in getting to know and supporting each member of my group.',
	},
	d15: {
		es: 'Busco ser productivo sabiendo en qué momento del día soy más eficaz.',
		pt: 'Busco ser produtivo sabendo em que momento do dia sou mais eficaz.',
		en: 'I aim to be productive by knowing at what time of day I am most effective.',
	},
	d16: {
		es: 'Hago planes realistas para el desarrollo de mí mismo, siendo consciente del tiempo, recursos y los cambios del entorno',
		pt: 'Faço planos realistas para o meu desenvolvimento, estando ciente do tempo, recursos e mudanças no ambiente.',
		en: 'I make realistic plans for my development, being aware of time, resources, and environmental changes.',
	},
	d17: {
		es: 'Reviso con frecuencia procesos y procedimientos.',
		pt: 'Reviso com frequência processos e procedimentos.',
		en: 'I frequently review processes and procedures.',
	},
	d18: {
		es: 'Soy capaz de desaprender para volver a aprender.',
		pt: 'Sou capaz de desaprender para reaprender.',
		en: 'I am capable of unlearning to relearn.',
	},
	d20: {
		es: 'Cuento con capacidad de generar alternativas frente a novedades que modifican el entorno.',
		pt: 'Tenho capacidade de gerar alternativas diante de novidades que alteram o ambiente.',
		en: 'I have the ability to generate alternatives in the face of changes that alter the environment.',
	},
	d21: {
		es: 'Mi capacidad de adaptación tiende a ser rápida y efectiva.',
		pt: 'Minha capacidade de adaptação tende a ser rápida e eficaz.',
		en: 'My ability to adapt tends to be quick and effective.',
	},
}
